import { render, staticRenderFns } from "./Brakedisc.vue?vue&type=template&id=b075842a&scoped=true"
import script from "./Brakedisc.vue?vue&type=script&lang=js"
export * from "./Brakedisc.vue?vue&type=script&lang=js"
import style0 from "./Brakedisc.vue?vue&type=style&index=0&id=b075842a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b075842a",
  null
  
)

export default component.exports